import styled from "styled-components";
import { Label } from "../InputField/inputFieldStyle";
import Select from "react-select";
import Typography from "../Typography/Typography";
export const SimpleSelect1 = ({
  label,
  onChange,
  res,
  value,
  defaultValue,
  important,
  placeholder,
  ref,
  onInputChange,
  className,
  onMenuOpen,
  isLoading,
  inputRef,
  loadingMessage,
  zIndex,
  getOptionLabel,
}) => {
  const valueRef = null;
  return (
    <SelectWrapper zIndex={zIndex}>
      {label ? (
        <Label className="d-flex">
          {label}
          {important ? <Typography primary="red">*</Typography> : null}
        </Label>
      ) : null}
      <Select
        value={value}
        isClearable
        placeholder={!placeholder ? "انتخاب کنید..." : placeholder}
        defaultValue={defaultValue}
        styles={{
          menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
          menu: (provided) => ({ ...provided, zIndex: 9999 }),
        }}
        className={className ? className : "w-100"}
        options={res}
        onChange={onChange}
        ref={inputRef ? inputRef : valueRef}
        onInputChange={onInputChange ? onInputChange : null}
        onMenuOpen={onMenuOpen}
        isLoading={isLoading}
        loadingMessage={loadingMessage}
        getOptionLabel={getOptionLabel}
      />
    </SelectWrapper>
  );
};

const SelectWrapper = styled.div`
  position: relative;
  z-index: ${(props) => (props.zIndex ? "9" : "")};
`;
